import { gql } from "@apollo/client";

export const NOTE_GROUP_FIELDS = gql`
  fragment NoteGroupFields on NoteGroup {
    uuid
    name
    notes {
      position
      note {
        uuid
        jobTypeName
        status
      }
    }
  }
`;
